import type { OpeningHours as OpeningHoursType } from 'lib-shared-types-api';
import { createElement, FunctionComponent } from 'react';

import {
  ListItemType,
  MenuType,
  useScheduleContext,
} from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';

import { AudioMessage } from './components/audioMessage/audioMessage';
import { AutoReply } from './components/autoReply/autoReply';
import { OpeningHours } from './components/openingHours/openingHours';

type Props = {
  index: number;
  item: OpeningHoursType;
};

export type ListItemComponentProps = {
  className?: string;
  hasConflict?: boolean;
  index: number;
  itemClassName?: string;
  name?: string;
  openingHours: OpeningHoursType;
  overrideException?: null | OpeningHoursType;
};

const regularName = 'Outside business hours';

const listItem: Record<MenuType, FunctionComponent<ListItemComponentProps>> = {
  hours: OpeningHours,
  audioMessages: AudioMessage,
  autoReplies: AutoReply,
};

export const ListItem = ({ index, item }: Props): JSX.Element => {
  const { id, overridden_by, opening_hour_type: openingHourType } = item;
  const isRegular = openingHourType === 'regular';

  const {
    activeView: { menu: activeMenu },
    conflicts,
    listItems,
  } = useScheduleContext();

  const hasConflict = !isRegular && id in conflicts;

  // Whether the opening hour is already overridden by another item
  const overrideException =
    (!isRegular &&
      overridden_by &&
      listItems[ListItemType.Exception].find(
        ({ id }) => id === overridden_by?.id,
      )) ||
    null;

  const props: ListItemComponentProps = {
    hasConflict,
    index,
    openingHours: item,
    overrideException: hasConflict ? null : overrideException,
    ...(activeMenu !== 'hours' && isRegular && { name: regularName }),
  };

  return createElement(listItem[activeMenu], props);
};
